import { useState } from "react";
import { useLang } from "../../i18n/LanguageContext";
import { downloads } from "../data/downloadsData";

const typeColors = {
  catalog: "text-blue-400 bg-blue-500/10",
  datasheet: "text-purple-400 bg-purple-500/10",
  certificate: "text-green-400 bg-green-500/10",
  standard: "text-orange-400 bg-orange-500/10",
};

export default function Downloads() {
  const { t } = useLang();
  const [active, setActive] = useState("all");
  const filters = ["all", "catalog", "datasheet", "certificate", "standard"];
  const filtered = active === "all" ? downloads : downloads.filter((d) => d.type === active);

  return (
    <section id="downloads" className="py-32 bg-[#141416] border-t border-white/5 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.downloads.label}</div>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white uppercase">{t.downloads.title}</h2>
          <div className="w-20 h-1 bg-[#F28C18] mx-auto rounded"></div>
          <p className="text-zinc-500 text-sm max-w-2xl mx-auto font-light leading-relaxed">{t.downloads.sub}</p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {filters.map((f) => (
            <button
              key={f}
              onClick={() => setActive(f)}
              className={`px-5 py-2.5 rounded text-xs font-black uppercase tracking-widest border transition-all ${
                active === f ? "bg-[#F28C18] text-black border-[#F28C18]" : "bg-white/5 text-zinc-400 border-white/5 hover:border-white/20"
              }`}
            >
              {t.downloads.filters[f]}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {filtered.map((d) => (
            <div key={d.id} className="group p-5 bg-[#111112] rounded-xl border border-white/5 hover:border-[#F28C18]/30 transition-all flex items-center gap-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${typeColors[d.type]}`}>
                <i className={`fas ${d.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-white text-xs font-black leading-snug mb-1 truncate">{d.title}</div>
                <div className="text-zinc-500 text-[10px] flex items-center gap-2">
                  <span className="uppercase">{d.brand}</span>
                  <span>·</span>
                  <span>{t.downloads.size}: {d.size}</span>
                  <span>·</span>
                  <span>{d.year}</span>
                </div>
              </div>
              <a
                href={d.file}
                className="flex-shrink-0 w-9 h-9 rounded-lg bg-[#F28C18]/10 hover:bg-[#F28C18] text-[#F28C18] hover:text-black flex items-center justify-center transition-all"
                title={t.downloads.download}
              >
                <i className="fas fa-download text-xs"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
